import { merchantApi } from '@/config/axios'
import type { RentalProductVO } from '@/api/rental/product'

export const getMerchantRentalProductPage = (params: any) =>
  merchantApi.get({ url: '/merchant-api/rental/product/page', params })

export const getMerchantRentalProduct = (id: number) =>
  merchantApi.get({ url: '/merchant-api/rental/product/get', params: { id } })

export const createMerchantRentalProduct = (data: RentalProductVO) =>
  merchantApi.post({ url: '/merchant-api/rental/product/create', data })

export const updateMerchantRentalProduct = (data: RentalProductVO) =>
  merchantApi.put({ url: '/merchant-api/rental/product/update', data })

export const deleteMerchantRentalProduct = (id: number) =>
  merchantApi.delete({ url: '/merchant-api/rental/product/delete', params: { id } })

export const updateMerchantRentalProductStatus = (id: number, status: number) =>
  merchantApi.put({ url: '/merchant-api/rental/product/update-status', params: { id, status } })

export const getMerchantRentalCategoryList = () =>
  merchantApi.get({ url: '/merchant-api/rental/category/list' })
